import EditTemplateProduct from "./EditTemplateProduct/EditTemplateProduct";
import React, {useEffect, useMemo} from "react";
import TemplateInstanceProvider, {ACTIONS} from "../../Providers/TemplateInstanceProvider";
import {RecentImagesProvider} from "../hooks/recentimages";
import useTemplateInstance from "../hooks/useTemplateInstance";
import {usePriceList} from "../../Providers/PriceListProvider";
import {useHistory} from "react-router";
import {useShoppingCart} from "../hooks/shoppingcart";


export default ({orderLine}) => {
    return <TemplateInstanceProvider>
        <RecentImagesProvider>
            <Wrapper orderLine={orderLine} />
        </RecentImagesProvider>
    </TemplateInstanceProvider>
}


const Wrapper = ({orderLine}) => {
    const [state, dispatch] = useTemplateInstance();
    const {getProductByUuid} = usePriceList();
    const history = useHistory();
    const { updateOrderLine } = useShoppingCart()

    useEffect(() => {
        const {template, resources, year} = orderLine.templates[0];
        const product =  getProductByUuid(orderLine.product.uuid);

        dispatch({
            type: ACTIONS.SET_TEMPLATE,
            template
        })

        dispatch({
            type: ACTIONS.SET_RESOURCES,
            resources
        })

        dispatch({
            type: ACTIONS.SET_PRODUCT,
            product
        })

        dispatch({
            type: ACTIONS.SET_YEAR,
            year
        })
    }, [orderLine]);

    const handleUpdateCart = (resources, year) => {
        const {template} = orderLine.templates[0];

        updateOrderLine({
            ...orderLine,
            template: {
                uuid: template.uuid,
                resources,
                year
            }
        })
            .then( () => {
                history.push('/cart')
            })
    }

    const handleGoBack = () => {
        history.push('/cart/')
    }

    return <EditTemplateProduct
                mode='update'
                handleGoBack={handleGoBack}
                updateCart={handleUpdateCart}
            />
}